import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { useHovered } from '../../../../hooks';
import { FadeView } from '../../../FadeView';
import { ContentfulImage } from '../../../Image';
import {
  IMAGE_SIZE,
  IMAGE_TRANSFORM_CONFIG_CONTENTFUL,
} from '../../ProductCardV2.constants';
import { type Props } from './ProductCardV2HoverImage.types';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2HoverImage = (props: Props) => {
  const { source, staticSource, alt } = props;

  // ─────────────────────────────────────────────────────────────────────

  const ref = useRef(null);
  const isHovered = useHovered(ref);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View
      ref={ref}
      style={styles.container}
      accessible={false}
      importantForAccessibility="no"
      pointerEvents="box-only"
    >
      <FadeView show={isHovered} style={styles.innerContainer}>
        <ContentfulImage
          baseUrl={source}
          staticBaseUrl={staticSource}
          options={IMAGE_TRANSFORM_CONFIG_CONTENTFUL}
          contentFit="cover"
          aria-label={alt}
          accessibilityRole="image"
          accessible={false}
          importantForAccessibility="no"
          style={styles.image}
          withLoadingSkeleton
        />
      </FadeView>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    bottom: 'auto',
    zIndex: 1,
    width: '100%',
    height: IMAGE_SIZE,
    padding: theme.spacing['2'],
  },
  innerContainer: {
    width: '100%',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: theme.radius.large,
  },
});
